import { ToastProps, useToast } from "@hellocarbo/lasagne";
import { useEffect, useState } from "react";
import { ActionFunctionArgs, Outlet } from "react-router";

import { PortalContainerContext } from "@/contexts";

export async function action({ request }: ActionFunctionArgs) {
  if (request.method === "DELETE") {
    // Get CSRF token from meta tag (needed for anything not GET)
    const csrfToken = document?.querySelector<HTMLMetaElement>(
      'meta[name="csrf-token"]'
    )?.content;

    const response = await fetch("/users/sign_out/", {
      method: "delete",
      headers: {
        "X-CSRF-Token": `${csrfToken}`,
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (response.status === 204) {
      window.location.href = "/users/sign_in";
    }
  }
}

function Root() {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const { toast } = useToast();

  // Retrieve data stored in session storage with the key "toast" (as a string)
  const toastDataJSON = sessionStorage.getItem("toast");

  useEffect(() => {
    // If there is toast data in session storage
    if (toastDataJSON) {
      // Parse the data
      const toastData = JSON.parse(toastDataJSON) as ToastProps;

      // Display the toast
      toast(toastData);

      // Delete toast data in session storage
      sessionStorage.removeItem("toast");
    }
  }, [toastDataJSON, toast]);

  return (
    <PortalContainerContext value={{ container }}>
      <Outlet />
      <div className="relative z-50" ref={setContainer} />
    </PortalContainerContext>
  );
}

export default Root;
